import modaldialog from "@/components/dialogs/modaldialog"
import { Component, Prop, Vue, Watch } from "vue-property-decorator"

@Component
export default class Dialog extends Vue {

    // Dialog in a component, shown/hidden with v-model attribute
    // https://stackoverflow.com/questions/48035310/open-a-vuetify-dialog-from-a-component-template-in-vuejs

    @Prop({ default: false })
    value!: boolean
    get show() {
        return this.value
    }
    set show(value: boolean) {
        modaldialog.set(this, this.fullscreen && value)
        this.$emit("input", value)
    }

    get fullscreen() {
        return false
    }

    @Watch("value")
    watchModal() {
        modaldialog.set(this, this.fullscreen && this.value)
    }


    @Prop() formName!: string
    @Prop() dialogType!: string
    @Prop() compareProp!: string
    @Prop() groupIdOrUuid!: string | number

    RECENT_DIALOG_SELECTIONS_KEY: string = "recent_dialog_selections"
    MAX_SELECTIONS: number = 3

    storeSelection(selected: any) {
        if (!this.groupIdOrUuid)
            return
        selected = Object.assign({}, selected)
        delete selected.__typename

        var recents: any[] = this.recents
        var existsOnIndex: number = recents.map((r: any) => r[this.compareProp]).indexOf(selected[this.compareProp])
        if (existsOnIndex > -1)
            recents.splice(existsOnIndex, 1)
        if (recents.length >= this.MAX_SELECTIONS)
            recents.pop()
        recents.unshift(selected)
        this.store(recents)
    }

    store(recents: any[]) {
        try {
            let recentDialogSelections = this.recentDialogSelections()
            if (!recentDialogSelections[this.groupIdOrUuid])
                recentDialogSelections[this.groupIdOrUuid] = {}
            if (!recentDialogSelections[this.groupIdOrUuid][this.formName])
            if (!recentDialogSelections[this.formName])
                recentDialogSelections[this.groupIdOrUuid][this.formName] = {}
            recentDialogSelections[this.groupIdOrUuid][this.formName][this.dialogType] = recents
            localStorage[this.RECENT_DIALOG_SELECTIONS_KEY] = JSON.stringify(recentDialogSelections)
        } catch (e) {
            this.resetLocalStorage(e)
        }
    }

    combineRecents(entities: any[], page: number | null = null, itemsPerPage: number | null = null): any[] | null {
        if (!entities) return []
        if (page && page > 1) return entities
        var recents = this.recents

        // exclude stored entities from combined list, only keep top
        var combined = [...recents, ...entities]
        combined = combined.filter((activity: any, index: number) => {
            return combined.map((a => a[this.compareProp])).indexOf(activity[this.compareProp]) === index
        })

        return itemsPerPage ? combined.slice(0, itemsPerPage) : combined
    }

    isRecent(item: any) {
        return this.recents.filter((r: any) => r[this.compareProp] == item[this.compareProp]).length > 0
    }

    get recents(): any[] {
        if (!this.groupIdOrUuid) return []
        try {
            let recentDialogSelections = this.recentDialogSelections()
            if (!(this.groupIdOrUuid in recentDialogSelections))
                recentDialogSelections[this.groupIdOrUuid] = {}
            let recentDialogSelectionsForGroup = recentDialogSelections[this.groupIdOrUuid]
            let recentsForDialogType: any[] = []
            if (this.formName in recentDialogSelectionsForGroup) {
                var storedFormData: any = recentDialogSelectionsForGroup[this.formName]
                if (this.dialogType in storedFormData)
                    recentsForDialogType = storedFormData[this.dialogType]
            }
            return recentsForDialogType
        } catch (e) {
            this.resetLocalStorage(e)
            return []
        }
    }

    recentDialogSelections() {
        if (!localStorage) {
            console.warn("[Dialog.ts]: no local storage in browser")
            return null
        }
        try {
            if (!(this.RECENT_DIALOG_SELECTIONS_KEY in localStorage))
                localStorage[this.RECENT_DIALOG_SELECTIONS_KEY] = "{}"
            return JSON.parse(localStorage[this.RECENT_DIALOG_SELECTIONS_KEY])
        } catch (e) {
            this.resetLocalStorage(e)
        }
    }

    resetLocalStorage(error: any) {
        console.error('[Dialog.ts]: Error parsing local storage, resetting', error)
        localStorage[this.RECENT_DIALOG_SELECTIONS_KEY] = "{}"
    }
}